// import getapiService from './http-Get.service';
import { DATA_API_CONSTANT } from './constant/api.constant';
import httpGetService from './http-Get.service';
import httpPutService from './http-put.service';
import httpDeleteService from './http-delete.service';
import httpPostService from './http.Post.service';
import httpPatchService from './http-patch.service';

const login = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.LOGIN, data);
};

const getOtp = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.GET_OTP, data);
};

const LogOut = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.LOGOUT_USER);
};

const verifyOtp = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.VERIFY_OTP, data);
};

const Register = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.REGISTER, data);
};

const forgotPasswordOtp = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.FORGOT_PASSWORD_OTP, data);
};

const resetPassword = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.RESET_PASSWORD, data);
};

const listorganizationusers = () => {
  return httpGetService.getDataFromAPI(
    DATA_API_CONSTANT.LIST_ORGANIZATION_USERS,
  );
};

const getOrganizationDetailsById = (id) => {
  const url = `${DATA_API_CONSTANT.GET_ORGANIZATION_DETAILS_ID}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const updateUser = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.UPDATE_USER, data);
};

const addUser = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.ADD_EMPLOYEE, data);
};

const getProfiledetails = (id) => {
  const url = `${DATA_API_CONSTANT.GET_EMPLOYEE}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const updateprofiledetails = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.UPDATE_PROFILE, data);
};

const clockin = () => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.CLOCK_IN);
};

const getclockin = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_CLOCKIN);
};

const clockout = () => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.PUT_CLOCKOUT);
};

const dailylogs = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.DAILY_LOGS);
};

const monthlylogs = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.MONTHLY_LOGS, data);
};

const admindailylogs = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.ADMIN_DAILY_LOGS);
};

const adminmonthlylogs = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.ADMIN_MONTHLY_LOGS, data);
};

const adminuserudpdate = (data) => {
  return httpPutService.putTOAPI(
    DATA_API_CONSTANT.ADMIN_USER_TIME_UPDATE,
    data,
  );
};

const getdocuments = (id) => {
  const url = `${DATA_API_CONSTANT.GET_DOCUMENTS}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const getdocumentsForAdmin = (id) => {
  const url = `${DATA_API_CONSTANT.GET_DOCUMENTS_FOR_ADMIN}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const uploadImage = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.POST_IMAGE, data);
};

const UploadDocs = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.UPLOAD_DOCUMENTS, data);
};

const getcompanyoverview = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_COMPANY_OVERVIEW);
};

const postcompanyoverview = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.POST_COMPANY_OVERVIEW, data);
};

const putstatutory = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.PUT_STATUTORY, data);
};

const postdepartment = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.POST_DEPARTMENT, data);
};

const getprofileimage = (id) => {
  const url = `${DATA_API_CONSTANT.GET_PROFILE_IMAGE}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const getdesignation = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_DESIGNATIONS);
};

const getdepartment = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_DEPARTMENT);
};

const deletedepartment = (data) => {
  return httpDeleteService.deleteDataFromAPI(
    DATA_API_CONSTANT.DELETE_DEPARTMENT,
    data,
  );
};

const updatedepartment = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.UPDATE_DEPARTMENT, data);
};

const deletedocs = (data) => {
  return httpDeleteService.deleteDataFromAPI(
    DATA_API_CONSTANT.DELETE_DOCS,
    data,
  );
};

const getdropdowns = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_DROPDOWNS);
};

const addDesignation = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.ADD_DESIGNATION, data);
};

const createworkweekrule = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.CREATE_WORKWEEK_RULE,
    data,
  );
};

const deleteworkweekrule = (id) => {
  return httpDeleteService.deleteDataFromAPI(
    DATA_API_CONSTANT.DELETE_WORKWEEK,
    id,
  );
};

const getworkweekrule = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_WORKWEEK_RULE);
};

const assignwork = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.ASSIGN_WORKWEEK, data);
};

const getorgworkrule = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.LIST_ORGRULES);
};

const Assignwork = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.ASSIGN_WORKRULE, data);
};

const getUsersandrules = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.LIST_USERS_RULES);
};

const getAssignedLeaveTypes = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_ASSIGNED_LEAVES);
};

const applyLeave = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.APPLY_LEAVE, data);
};

const getEmployeeLogs = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_EMPLOYEE_LOGS);
};

const getworkweekcalender = (id) => {
  const url = `${DATA_API_CONSTANT.GET_WORK_WEEK_CALENDER}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const updateRules = (data) => {
  return httpPutService.putTOAPI(
    DATA_API_CONSTANT.UPDATE_WORK_WEEK_RULES,
    data,
  );
};

const deleteUserRule = (data) => {
  return httpDeleteService.deleteDataFromAPI(
    DATA_API_CONSTANT.DELETE_USER_RULE,
    data,
  );
};

const getUserWorkweekRule = (id) => {
  const url = `${DATA_API_CONSTANT.GET_USER_WORK_WEEK_CALENDER}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const getLeaveDetails = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_LEAVE_DETAILS);
};

const deleteDesignation = (id) => {
  return httpDeleteService.deleteDataFromAPI(
    DATA_API_CONSTANT.DELETE_DESIGNATION,
    id,
  );
};

const updateLeaveDetails = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.UPDATE_LEAVE_DETAILS, data);
};

const getUserLeaveDetails = (user_id) => {
  return httpGetService.getDataFromAPI(
    DATA_API_CONSTANT.GET_USER_LEAVE_DETAILS + user_id,
  );
};

const getUserAssignedLeaves = (user_id) => {
  return httpGetService.getDataFromAPI(
    DATA_API_CONSTANT.GET_ASSIGNED_USER_LEAVES + user_id,
  );
};

const getLeaveViewDetails = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.GET_LEAVE_VIEW_DETAILS,
    data,
  );
};

const deleteLeaveApplication = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.DELETE_LEAVE_APPLICATION,
    data,
  );
};

const deletePayrollStructure = (id) => {
  const url = `${DATA_API_CONSTANT.DELETE_PAYROLE_STRUCTURE}${id}`;
  return httpDeleteService.deleteDataFromAPI(url);
};

const deleteUser = (id) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.DELETE_USER, id);
};

const listorganization = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.LIST_ORGANIZATIONS);
};

const updateorganization = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.UPDATE_ORGANIZATION, data);
};

const deleteorganization = (Id) => {
  return httpDeleteService.deleteDataFromAPI(
    DATA_API_CONSTANT.DELETE_ORGANIZATION,
    Id,
  );
};

const verifyDocument = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.VERIFY_DOCUMENT, data);
};

const getUsersDetails = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_USERS_DETAILS);
};

const signInwithotp = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.SIGN_IN_OTP, data);
};

const getLeaveRecordsData = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.LEAVE_RECORDS_DATA);
};

const updateUserStatus = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.UPDATE_USER_STATUS, data);
};

// taskmanagement api's

const getProjects = () => {
  return httpGetService.getDataFromAPI(
    DATA_API_CONSTANT.TASK_MANAGEMENT_LIST_PROJECTS,
  );
};

const addProject = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.TASK_MANAGEMENT_ADD_PROJECT,
    data,
  );
};

const getDepartmentsForTaskManagement = () => {
  return httpGetService.getDataFromAPI(
    DATA_API_CONSTANT.TASK_MANAGEMENT_GET_DEPARTMENTS,
  );
};

const getUsersByDepartment = (department_Id) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.TASK_MANAGEMENT_GET_USERS_BY_DEPARTMENT,
    department_Id,
  );
};

const AddTaskWithoutEpic = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.ADD_TASK_WITHOUT_EPIC,
    data,
  );
};

const getProjectAssignedEmployeelist = (id) => {
  const url = `${DATA_API_CONSTANT.GET_PROJECT_ASIGNED_EMPLOYEELIST}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const getTaskBoardDetails = (id) => {
  const url = `${DATA_API_CONSTANT.GET_TASK_BOARD_DETAILS}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const taskUpdateStatus = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.TASK_UPDATE_STATUS, data);
};

const ListBoardStatus = (id) => {
  const url = `${DATA_API_CONSTANT.LIST_TASK_BOARD_STATUS}${id}`;
  return httpGetService.getDataFromAPI(url);
  //  return httpPostService.postTOAPI(DATA_API_CONSTANT.LIST_TASK_BOARD_STATUS, id);
};

const TaskUpdateTitleAssignee = (data) => {
  return httpPutService.putTOAPI(
    DATA_API_CONSTANT.TASK_UPDATE_TITLE_ASSIGNEE,
    data,
  );
};

const deleteTask = (Id) => {
  return httpDeleteService.deleteDataFromAPI(DATA_API_CONSTANT.DELETE_TASK, Id);
};

const getlabelList = (id) => {
  const url = `${DATA_API_CONSTANT.LIST_LABEL}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const createLabel = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.CREATE_LABEL, data);
};

const updateLabel = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.UPDATE_LABEL, data);
};

const Taskedit = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.TASK_EDIT, data);
};

const gettaskdata = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.GET_TASK_DATA, data);
};

const getsprintList = (Id) => {
  const url = `${DATA_API_CONSTANT.GET_SPRINT_LIST}${Id}`;
  return httpGetService.getDataFromAPI(url);
};

const addComments = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.ADD_TASK_COMMENTS, data);
};

const gettaskcomments = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.GET_TASK_COMMENTS, data);
};

const addSubtask = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.ADD_SUBTASK, data);
};

const getsubtaskList = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.GET_SUBTASK_LIST, data);
};

const updateSubtask = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.UPDATE_SUBTASK, data);
};

const addBoardstatus = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.ADD_BOARD_STATUS, data);
};

const taskCreateSprint = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.TASK_MGMT_CREATE_SPRINT,
    data,
  );
};

const taskStartSprint = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.TASK_MGMT_START_SPRINT,
    data,
  );
};

const taskUpdateSprint = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.TASK_MGMT_UPDATE_SPRINT,
    data,
  );
};

const getSprintBacklogData = (project_id) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.GET_SPRINT_BACKLOG_DATA,
    project_id,
  );
};

const deleteSprint = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.DELETE_SPRINT, data);
};

const addTaskToSprint = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.CREATE_TASK_SPRINT, data);
};

const createTaskToBacklog = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.CREATE_TASK_TO_BACKLOG,
    data,
  );
};

const updateTaskFromSprint = (data) => {
  return httpPutService.putTOAPI(
    DATA_API_CONSTANT.UPDATE_TASK_FROM_SPRINT,
    data,
  );
};

const updateTaskFromBacklog = (data) => {
  return httpPutService.putTOAPI(
    DATA_API_CONSTANT.UPDATE_TASK_FROM_BACKLOG,
    data,
  );
};

const completeSprint = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.COMPLETE_SPRINT, data);
};

const getSprintTaskSummary = (Id) => {
  const url = `${DATA_API_CONSTANT.GET_TASK_SUMMARY}${Id}`;
  return httpGetService.getDataFromAPI(url);
};

const moveTaskToSprint = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.MOVE_TASK_TO_SPRINT, data);
};

const updateTaskwithSprint = (data) => {
  return httpPutService.putTOAPI(
    DATA_API_CONSTANT.Task_UPDATE_WITH_SPRINTID,
    data,
  );
};

const getProjectAssigneeList = (id) => {
  const url = `${DATA_API_CONSTANT.GET_PROJECT_ASSIGNEE_LIST}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const getEpicList = (projectId) => {
  const url = `${DATA_API_CONSTANT.GET_EPIC_LIST}?project_id=${projectId}`;
  return httpGetService.getDataFromAPI(url);
};

const taskManagementDeactivateProject = (id) => {
  const url = `${DATA_API_CONSTANT.TASK_MANAGEMENT_DEACTIVATE_PROJECT}${id}`;
  return httpPutService.putTOAPI(url);
};

const getLabelList = (id) => {
  const url = `${DATA_API_CONSTANT.GET_LABEL_LIST}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const getStatusList = (projectId) => {
  const url = `${DATA_API_CONSTANT.GET_STATUS_LIST}?project_id=${projectId}`;
  return httpGetService.getDataFromAPI(url);
};

const filteringBoardPage = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.TASK_MANAGEMENT_BOARD_FILTER,
    data,
  );
};

const boardFilterSprints = (id) => {
  const url = `${DATA_API_CONSTANT.BOARD_FILTER_SPRINTS}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const boardFilterAssignments = (id) => {
  const url = `${DATA_API_CONSTANT.GET_PROJECT_ASIGNED_EMPLOYEELIST}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const boardFilterLabels = (id) => {
  const url = `${DATA_API_CONSTANT.BOARD_FILTER_LABELS}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const boardFilterStatus = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.BOARD_FILTER_STATUS, data);
};

const boardFilterEpics = (id) => {
  const url = `${DATA_API_CONSTANT.BOARD_FILTER_EPICS}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const taskManagementEditProject = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.TASK_MANAGEMENT_EDIT_PROJECT,
    data,
  );
};

const taskManagementDeleteProject = (id) => {
  const url = `${DATA_API_CONSTANT.TASK_MANAGEMENT_DELETE_PROJECT}${id}`;
  return httpDeleteService.deleteDataFromAPI(url);
};

const taskManagementGetUnselectedEmployees = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.TASK_MANAGEMENT_GET_UNSELECTED_EMPLOYEES,
    data,
  );
};

const updateProjectDepartments = (data) => {
  return httpPutService.putTOAPI(
    DATA_API_CONSTANT.TASK_MANAGEMENT_UPDATE_PROJECT_DEPARTMENTS,
    data,
  );
};

const updateProjectTeamMembers = (data) => {
  return httpPutService.putTOAPI(
    DATA_API_CONSTANT.TASK_MANAGEMENT_ADD_PROJECT_MEMBERS,
    data,
  );
};
const gettaskDetailsbyEpicId = (Id) => {
  const url = `${DATA_API_CONSTANT.GET_TASK_BOARD_DEATILS_BY_EPICID}${Id}`;
  return httpGetService.getDataFromAPI(url);
};

const gettaskDetailswithoutepic = (Id) => {
  const url = `${DATA_API_CONSTANT.GET_TASK_BOARD_WITHOUT_EPIC}${Id}`;
  return httpGetService.getDataFromAPI(url);
};

const delete_subtask = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.SUBTASK_DELETE, data);
};
const delete_status_column = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.DELETE_STATUS_COLUMN,
    data,
  );
};

const update_subtask_fields = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.UPDATE_SUBTASK_FIELDS, data);
};

const taskManagementGetProjectDetails = (id) => {
  const url = `${DATA_API_CONSTANT.TASK_MANAGEMENT_GET_PROJECT_DETAILS}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const taskManagementRemoveTeamMembers = (data) => {
  return httpPutService.putTOAPI(
    DATA_API_CONSTANT.TASK_MANAGEMENT_REMOVE_PROJECT_MEMBERS,
    data,
  );
};

const get_epic = (id) => {
  const url = `${DATA_API_CONSTANT.GET_EPIC}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const getSingleProjectPermission = (id) => {
  const url = `${DATA_API_CONSTANT.GET_SELECTED_PROJECT_ROLE_PERMISSION}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const getALLProjectRolePermissions = (id) => {
  const url = `${DATA_API_CONSTANT.GET_ALL_PROJECT_ROLE_PERMISSIONS}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const addWorkItem = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.ADD_WORK_ITEM, data);
};

const taskManagementAddEpic = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.TAST_MANAGEMENT_ADD_EPIC,
    data,
  );
};
const updateBoardStatusorder = (data) => {
  return httpPutService.putTOAPI(
    DATA_API_CONSTANT.UPDATE_BOARD_STATUS_ORDER,
    data,
  );
};

const filterBacklogTask = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.BACKLOG_PAGE_FILTER, data);
};

const getCurrentSprintTask = (Id) => {
  const url = `${DATA_API_CONSTANT.GET_CURRENT_SPRINT_TASKDETAILS}${Id}`;
  return httpGetService.getDataFromAPI(url);
};

const exportTaskData = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.EXPORT_TASK_DATA, data);
};

const getUpcomingFestivals = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.UPCOMING_FESTIVALS);
};

const getTodaysLeaveMembers = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.TODAYS_LEAVE_MEMBERS);
};

const getBirthDayList = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.BIRTHDAY_LIST);
};

const getWorkAnniversary = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.WORK_ANNIVERSARY);
};

const getNewJoinersList = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.NEW_JOINERS_LIST);
};

const sendBirthDayWish = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.SEND_BIRTHDAY_WISH, data);
};

const getDailyThoughts = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_DAILY_THOUGHTS);
};

// chatbot logic here
const getChatbotData = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.CHAT_BOT, data);
};

const getActiveUsers = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_ACTIVE_USERS);
};

const timeline_Sprintlist = (Id) => {
  const url = `${DATA_API_CONSTANT.TIMELINE_SPRINT_LIST}${Id}`;
  return httpGetService.getDataFromAPI(url);
};

const timeline_Epiclist = (Id) => {
  const url = `${DATA_API_CONSTANT.TIMELINE_GETEPIC_LIST}${Id}`;
  return httpGetService.getDataFromAPI(url);
};

const gettimelinetask = (Id) => {
  const url = `${DATA_API_CONSTANT.TIMELINE_TASK_LIST}${Id}`;
  return httpGetService.getDataFromAPI(url);
};

const UpdateTimelineTaskEpic = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.UPDATE_TIMELINE_TASKEPIC,
    data,
  );
};

const UpdateEpicDetails = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.UPDATE_EPIC_DETAILS, data);
};

const UpdatesprintsDetails = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.UPDATE_SPRINTS_DETAILS,
    data,
  );
};

const addtaskwithEpic = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.ADD_TASK_WITH_EPIC, data);
};

const getFeatureList = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.FEATURE_LIST);
};

const addFeature = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.ADD_FEATURE, data);
};

const assignFeature = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.ASSIGN_FEATURE, data);
};

const getAssignedFeatureOrg = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.ASSIGNED_FEATURE_ORG);
};

const deleteFeature = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.DELETE_FEATURE, data);
};

const deleteAssignedFeature = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.DELETE_ASSIGNED_FEATURE,
    data,
  );
};

const timelinefilterDetails = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.GET_TIMELINE_FILTERED_LIST,
    data,
  );
};

const edit_comment = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.EDIT_COMMENT, data);
};

const addEpicComments = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.ADD_EPIC_COMMENT, data);
};

const getEpicComments = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.GET_EPIC_COMMENT, data);
};

const editEpiccomment = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.EDIT_EPIC_COMMENT, data);
};

const deletetaskcomment = (Id) => {
  return httpDeleteService.deleteDataFromAPI(
    DATA_API_CONSTANT.DELETE_TASK_COMMENT,
    Id,
  );
};

const getEpicdetails = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.GET_EPIC_DETAILSBYID,
    data,
  );
};

const getSubtaskById = (Id) => {
  const url = `${DATA_API_CONSTANT.GET_SUBTASK_DETAILS_BYID}${Id}`;
  return httpGetService.getDataFromAPI(url);
};

const getsubtaskComments = (Id) => {
  const url = `${DATA_API_CONSTANT.GET_SUBTASK_COMMENTS}${Id}`;
  return httpGetService.getDataFromAPI(url);
};

const updateSubtaskLabels = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.UPDATE_SUBTASK_LABELS,
    data,
  );
};

const gettaskwithEpicId = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.GET_TASK_WITH_EPICID,
    data,
  );
};

const createandADDepicLabels = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.CREATE_ADD_EPIC_LABELS,
    data,
  );
};

const deleteEpicComment = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.DELETE_EPIC_COMMENT, data);
};
const updatesubtaskdata = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.UPDATE_SUBTASK_DATA, data);
};

const postSubtaskComment = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.CREATE_SUBTASK_COMMENT,
    data,
  );
};

const editSubtaskComment = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.EDIT_SUBTASK_COMMENT, data);
};

const Deletesubtaskcomment = (Id) => {
  return httpDeleteService.deleteDataFromAPI(
    DATA_API_CONSTANT.DELETE_SUBTASKCOMMENT,
    Id,
  );
};
const getProjectTaskSubTaskData = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.GET_EPICS_AND_TASKS_WITH_SUBTAKS,
    data,
  );
};

// TASK MANAGEMENT SUMMARY DASHBOARD API'S

const getSummaryDashboard = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.GET_SUMMARY_DASHBOARD,
    data,
  );
};

// Organization List And Invite Users
const getOrgUsersList = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_ORG_USERS_DETAILS);
};

const inviteUsersToOrg = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.INVITE_TO_ORG, data);
};

const acceptOrgInvite = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.ACCEPT_ORG_INVITE, data);
};
const updateEpicposition = (data) => {
  return httpPatchService.patchTOAPI(
    DATA_API_CONSTANT.UPDATE_EPIC_POSITION,
    data,
  );
};

const getListData = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.GET_LIST_DATA, data);
};

const reorderTaskSprint = (data) => {
  return httpPatchService.patchTOAPI(
    DATA_API_CONSTANT.REODRDER_TASK_IN_SPRINT,
    data,
  );
};

const listFilteredDetails = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.LIST_FILTER_DETAILS, data);
};
const getAdminTaskBoardDetails = (Id) => {
  const url = `${DATA_API_CONSTANT.GET_ADMINTASK_BOARD_DETAILS}${Id}`;
  return httpGetService.getDataFromAPI(url);
};

const sendProjectInvite = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.INVITE_TO_PROJECT, data);
};

const acceptProjectInvite = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.ACCEPT_PROJECT_INVITE,
    data,
  );
};

const adminBoardDetails = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.ADMIN_BOARD_FILTER, data);
};

// attachment api's
const uploadAttachment = (formData) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.UPLOAD_ATTACHMENT,
    formData,
  );
};

const getAttachment = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.GET_ATTACHMENT, data);
};

const deleteAttachment = (data) => {
  return httpDeleteService.deleteDataFromAPI(
    DATA_API_CONSTANT.DELETE_ATTACHMENT,
    data,
  );
};

const downloadAttachment = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.DOWNLOAD_ATTACHMENT, data);
};
// attachment's api end

// share work item api
const shareWorkItem = (data) => {
 
  return httpPostService.postTOAPI(DATA_API_CONSTANT.SHARE_WORK_ITEM, data);
};

const getIssueTypes = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_ISSUE_TYPES);
};
// share work item api end

//dashboard metrics api's(main api based on roles)
const getDashboardMetrics = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.DASHBOARD_METRICS, data);
};

const timeTracking = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.TIME_TRACKING, data);
};

const getLoggedTime = (Id) => {
  const url = `${DATA_API_CONSTANT.GET_LOGGED_TIME}${Id}`;
  return httpGetService.getDataFromAPI(url);
};
const getHistoricalWorkLogs = (Id) => {
  const url = `${DATA_API_CONSTANT.GET_HISTORICAL_LOGS}${Id}`;
  return httpGetService.getDataFromAPI(url);
};

const getWorkLogTime = (Id) => {
  const url = `${DATA_API_CONSTANT.GET_WORKLOG_TIME}${Id}`;
  return httpGetService.getDataFromAPI(url);
};

const updateLogTime = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.UPDATE_LOG_TIME, data);
};

const deleteLoggedTime = (data) => {
  return httpDeleteService.deleteDataFromAPI(
    DATA_API_CONSTANT.DELETE_LOG_TIME,
    data,
  );
};

const listLinkTypes = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.LIST_LINK_TYPES);
};

const createLinkType = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.CREATE_LINK_TYPES, data);
};

const listOfWorkItemstoLink = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.LIST_WORKITEMS_FOR_LINKING,
    data,
  );
};

const LinkWorkItems = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.LINK_WORK_ITEMS, data);
};

const deletelinkType = (Id) => {
  const url = `${DATA_API_CONSTANT.DELETE_WORK_ITEM}${Id}`;
  return httpDeleteService.deleteDataFromAPI(url);
};

const updateLinkTypeStatus = (data) => {
  return httpPutService.putTOAPI(
    DATA_API_CONSTANT.UPDATE_LINK_TYPE_STATUS,
    data,
  );
};

const getLinkedWorkItems = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.GET_LINKED_WORKITEMS,
    data,
  );
};

const fetchLinkedWorkItemsCount = (Id) => {
  const url = `${DATA_API_CONSTANT.FETCH_LINKEDWORK_ITEMS_COUNT}${Id}`;
  return httpGetService.getDataFromAPI(url);
};

const deleteLinkType = (data) => {
  return httpDeleteService.deleteDataFromAPI(
    DATA_API_CONSTANT.DELETE_LINK_TYPE,
    data,
  );
};

// confleunce api's start

const getIcons = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_ICONS);
};

const createSpace = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.CREATE_SPACE, data);
};

const getSpaces = (data) => {
  return httpGetService.getDataFromAPI(
    DATA_API_CONSTANT.GET_SPACES +
      '?filter_type=' +
      data.filter_type +
      (data.category_id ? '&category_id=' + data.category_id : ''),
  );
};

const getSpaceDetails = (data) => {
  return httpGetService.getDataFromAPI(
    DATA_API_CONSTANT.GET_SPACE_DETAILS + '?space_id=' + data.space_id,
  );
};

const getSpaceContent = (data) => {
  return httpGetService.getDataFromAPI(
    DATA_API_CONSTANT.GET_SPACE_CONTENT + data.space_id + '/get-all-documents',
  );
};

const getYourSpaces = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_YOUR_SPACES);
};

const getTrashedSpaces = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_TRASHED_SPACES);
};

const createPageDraft = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.DRAFT_PAGE, data);
};

const createFolder = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.CREATE_FOLDER, data);
};

const renameContent = (data) => {
  return httpPatchService.patchTOAPI(DATA_API_CONSTANT.RENAME_CONTENT, data);
};

const getTemplate = (data) => {
  return httpGetService.getDataFromAPI(
    DATA_API_CONSTANT.GET_TEMPLATE + '?type=' + data.type,
  );
};

const postPageContent = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.EDIT_PAGE_CONTENT, data);
};

const getPageContent = (space_id, item_id) => {
  const url = DATA_API_CONSTANT.GET_PAGE_CONTENT.replace(
    ':space_id',
    space_id,
  ).replace(':item_id', item_id);

  return httpGetService.getDataFromAPI(url);
};

const movePageOrFolders = (data) => {
  return httpPatchService.patchTOAPI(
    DATA_API_CONSTANT.MOVE_PAGE_OR_FOLDERS,
    data,
  );
};

const deleteorArchivePgorFolder = (data) => {
  return httpPatchService.patchTOAPI(
    DATA_API_CONSTANT.ARCHIVE_OR_DELETE_PAGE_FOLDER,
    data,
  );
};

const duplicateContent = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.DUPLICATE_CONTENT, data);
};

const templateDraftPage = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.TEMPLATEDRAFTPAGE, data);
};

const starShortcut = (data) => {
  return httpPatchService.patchTOAPI(DATA_API_CONSTANT.STAR_SHORTCUT, data);
};

const publishPage = (data) => {
  return httpPatchService.patchTOAPI(DATA_API_CONSTANT.PUBLISH_PAGE, data);
};

const getSpaceUser = (space_id) => {
  const url = DATA_API_CONSTANT.GETSPACEUSERS.replace(':space_id', space_id);
  return httpGetService.getDataFromAPI(url);
};

const postpageComment = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.POST_PAGE_COMMENT, data);
};

const getPageComment = (space_id, item_id, type) => {
  const url = DATA_API_CONSTANT.GET_PAGE_COMMENT.replace(':space_id', space_id)
    .replace(':item_id', item_id)
    .replace(':type', type);
  return httpGetService.getDataFromAPI(url);
};

const editPageComment = (data) => {
  return httpPutService.putTOAPI(DATA_API_CONSTANT.EDIT_PAGE_COMMENT, data);
};

const deletePageComment = (space_id, item_id, id) => {
  const url = DATA_API_CONSTANT.DELETE_PAGE_COMMENT.replace(
    ':space_id',
    space_id,
  )
    .replace(':item_id', item_id)
    .replace(':id', id);
  return httpDeleteService.deleteDataFromAPI(url);
};

const shareItem = (data) => {
  const url = DATA_API_CONSTANT.SHAREITEM.replace(':item_id', data.item_id);
  return httpPostService.postTOAPI(url, data);
};

const getArchivedSpaces = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_ARCHIVED_SPACE);
};

const restoreOrTrash = (data) => {
  return httpPatchService.patchTOAPI(
    DATA_API_CONSTANT.PATCH_RESTORE_OR_TRASH,
    data,
  );
};

const getVersionHistory = (space_id, item_id, type) => {
  const url = DATA_API_CONSTANT.GET_VERSION_HISTORY.replace(
    ':space_id',
    space_id,
  )
    .replace(':item_id', item_id)
    .replace(':type', type);
  return httpGetService.getDataFromAPI(url);
};

const getStarredContent = (space_id) => {
  const url = DATA_API_CONSTANT.GET_STARRED_CONTENT.replace(
    ':space_id',
    space_id,
  );
  return httpGetService.getDataFromAPI(url);
};

const postSpaceAttachment = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.UPLOAD_SPACE_ATTACHMENT,
    data,
  );
};

const getSpaceAttachments = (space_id, item_id) => {
  const url = DATA_API_CONSTANT.GET_SPACE_ATTACHMENT.replace(
    ':space_id',
    space_id,
  ).replace(':item_id', item_id);
  return httpGetService.getDataFromAPI(url);
};

const deleteSpaceAttachment = (space_id, item_id, id) => {
  const url = DATA_API_CONSTANT.DELETE_SPACE_ATTACHMEMT.replace(
    ':space_id',
    space_id,
  )
    .replace(':item_id', item_id)
    .replace(':id', id);
  return httpDeleteService.deleteDataFromAPI(url);
};

const geOwnerSpaces = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_OWNER_SPACE);
};

const getArchivedandDeletedItems = (id) => {
  const url = `${DATA_API_CONSTANT.GET_DELETE_AND_ARCHIVED_CONTENT}${id}`;
  return httpGetService.getDataFromAPI(url);
};

const restoreTrashedContent = (data) => {
  return httpPatchService.patchTOAPI(
    DATA_API_CONSTANT.RESTORE_TRASHED_CONTENT,
    data,
  );
};

const deleteDraftPage = (space_id, item_id) => {
  const url = DATA_API_CONSTANT.DELETE_DRAFT_PAGE.replace(
    ':space_id',
    space_id,
  ).replace(':item_id', item_id);
  return httpDeleteService.deleteDataFromAPI(url);
};

const compareVersion = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.COMPARE_VERSION, data);
};

const savePageData = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.SAVE_PADE_DATA, data);
};

const restorePageVersion = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.RESTORE_VERSION, data);
};

const deleteVersion = (space_id, item_id, version_id) => {
  const url = DATA_API_CONSTANT.DELETE_VERSION.replace(':space_id', space_id)
    .replace(':item_id', item_id)
    .replace(':version_id', version_id);
  return httpDeleteService.deleteDataFromAPI(url);
};

const getAllOrgUsers = () => {
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.LIST_ALL_ORG_USERS);
};

const addUsersToSpace = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.ADD_USERS_TO_SPACE, data);
};

const permanentlyDeleteItem = (space_id, item_id) => {
  const url = DATA_API_CONSTANT.PERMANENTLY_DELETE_ITEM.replace(
    ':space_id',
    space_id,
  ).replace(':item_id', item_id);
  return httpDeleteService.deleteDataFromAPI(url);
};

const removeMembersFromSpace = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.REMOVE_MEMBERS_FROM_SPACE,
    data,
  );
};

const createWhiteBoard = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.CREATE_WHITEBOARD, data);
};

const postWhiteboardContent = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.POST_WHITEBOARD_CONTENT,
    data,
  );
};

const getVersionDetails = (space_id, version_id) => {
  const url = DATA_API_CONSTANT.GET_VERSION_DETAILS.replace(
    ':space_id',
    space_id,
  ).replace(':version_id', version_id);
  return httpGetService.getDataFromAPI(url);
};

const createDatabase = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.CREATE_DATABASE, data);
};

const getColumnList = (space_id, item_id) => {
  const url = DATA_API_CONSTANT.GET_COLUMN_LIST.replace(
    ':space_id',
    space_id,
  ).replace(':item_id', item_id);
  return httpGetService.getDataFromAPI(url);
};

const databaseFilters=(data)=>{
  return httpPostService.postTOAPI(DATA_API_CONSTANT.DATABSE_FILTERS,data)
}

const getSavedFilters=(space_id,item_id)=>{
  const url =DATA_API_CONSTANT.GET_SAVED_FILTERS
  .replace(':space_id',space_id)
  .replace(':item_id',item_id)
  return httpGetService.getDataFromAPI(url)
}

const deleteSavedFilters=(space_id,item_id,id)=>{
  const url = DATA_API_CONSTANT.DELETE_SAVED_FILTERS
  .replace(":space_id",space_id)
  .replace(":item_id",item_id)
  .replace(":id",id)
  return httpDeleteService.deleteDataFromAPI(url)
}

const columnCalculation=(data)=>{
return httpPostService.postTOAPI(DATA_API_CONSTANT.DATABASE_COLUMN_CALCULATION,data)
}

const contentExport=(data)=>{
  return httpPostService.postTOAPI(DATA_API_CONSTANT.CONTENT_EXPORT,data,{ responseType: 'arraybuffer' } )
}

const allSpacePermission=()=>{
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.ALL_SPACE_PERMISSION)
}

const singleSpacePermission=(space_id)=>{
  const url = DATA_API_CONSTANT.SINGLE_SPACE_PERMISSION
  .replace(":space_id",space_id)
  return httpGetService.getDataFromAPI(url)
}

// confluence api's end

const updateHorizontalDashboardConfig = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.UPDATE_HORIZONTAL_DASHBOARD_CONFIG,
    data,
  );
};

const getHorizontalDashboardConfig = () => {
  const url = `${DATA_API_CONSTANT.GET_HORIZONTAL_DASHBOARD_CONFIG}`;
  return httpGetService.getDataFromAPI(url);
};

const updateMetricSequence = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.UPDATE_METRIC_SEQUENCE,
    data,
  );
};

const getMetricSequence = () => {
  const url = `${DATA_API_CONSTANT.GET_METRIC_SEQUENCE}`;
  return httpGetService.getDataFromAPI(url);
};

const getVerticalDashboardConfig = () => {
  const url = `${DATA_API_CONSTANT.GET_VERTICAL_DASHBOARD_CONFIG}`;
  return httpGetService.getDataFromAPI(url);
};

const updateVerticalDashboardConfig = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.UPDATE_VERTICAL_DASHBOARD_CONFIG,
    data,
  );
};

const getVerticalWidgetSequence = () => {
  const url = `${DATA_API_CONSTANT.GET_VERTICAL_DASHBOARD_SEQUENCE}`;
  return httpGetService.getDataFromAPI(url);
};

const updateVerticalWidgetSequence = (data) => {
  return httpPostService.postTOAPI(
    DATA_API_CONSTANT.UPDATE_VERTICAL_DASHBOARD_SEQUENCE,
    data,
  );
};

// weblinlk

const addWebLink = (data) => {
  return httpPostService.postTOAPI(DATA_API_CONSTANT.ADD_WEB_LINK, data);
};

const getWebLink = (Id) => {
  const url = `${DATA_API_CONSTANT.GET_WEB_LINKS}${Id}`;
  return httpGetService.getDataFromAPI(url);
};

const deleteWebLink = (data) => {
  return httpDeleteService.deleteDataFromAPI(
    DATA_API_CONSTANT.DELETE_WEB_LINKS,
    data,
  );
};

const createDemoProject=()=>{
  return httpPostService.postTOAPI(DATA_API_CONSTANT.CREATE_DEMO_PROJECT)
}

const updateTourStatus = (data) => {
  return httpPutService.putTOAPI( DATA_API_CONSTANT.UPDATE_TOUR_STATUS, data);
};

const updateProjectTourStatus=(data)=>{
  return httpPutService.putTOAPI(DATA_API_CONSTANT.UPDATE_PROJECT_TOUR_STATUS, data);
}

const getSubscriptionPlans=()=>{
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_SUBSCRIPTION_PLANS);
}

const createPlan=(data)=>{
  return httpPostService.postTOAPI(DATA_API_CONSTANT.CREATE_SUBSCRIPTION, data)
}

const updatePlan=(data)=>{
  return httpPutService.putTOAPI(DATA_API_CONSTANT.UPDATE_SUBSCRIPTION, data)
}

const changePlanStatus=(data)=>{
  return httpPutService.putTOAPI(DATA_API_CONSTANT.CHANGE_PLAN_STATUS, data)

}

const getOrgSubscription=()=>{
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_ADMIN_LIST)

}

const assignPlan=(data)=>{
  return httpPostService.postTOAPI(DATA_API_CONSTANT.ASSIGN_PLAN, data)
}

const authService = {
  login,
  getOtp,
  verifyOtp,
  Register,
  forgotPasswordOtp,
  resetPassword,
  listorganizationusers,
  getOrganizationDetailsById,
  updateUser,
  addUser,
  getProfiledetails,
  updateprofiledetails,
  clockin,
  getclockin,
  clockout,
  dailylogs,
  monthlylogs,
  admindailylogs,
  adminmonthlylogs,
  adminuserudpdate,
  getdocuments,
  uploadImage,
  UploadDocs,
  getcompanyoverview,
  postcompanyoverview,
  putstatutory,
  postdepartment,
  getprofileimage,
  getdesignation,
  deleteDesignation,
  getdepartment,
  deletedepartment,
  updatedepartment,
  deletedocs,
  getdropdowns,
  addDesignation,
  createworkweekrule,
  deleteworkweekrule,
  getworkweekrule,
  assignwork,
  getorgworkrule,
  Assignwork,
  getUsersandrules,
  getAssignedLeaveTypes,
  applyLeave,
  getEmployeeLogs,
  getworkweekcalender,
  updateRules,
  deleteUserRule,
  getUserWorkweekRule,
  getLeaveDetails,
  updateLeaveDetails,
  getUserLeaveDetails,
  getUserAssignedLeaves,
  getLeaveViewDetails,
  deleteLeaveApplication,
  deletePayrollStructure,
  deleteUser,
  listorganization,
  updateorganization,
  deleteorganization,
  getdocumentsForAdmin,
  verifyDocument,
  LogOut,
  getUsersDetails,
  signInwithotp,
  getLeaveRecordsData,
  updateUserStatus,
  getProjects,
  addProject,
  getDepartmentsForTaskManagement,
  getUsersByDepartment,
  AddTaskWithoutEpic,
  getProjectAssignedEmployeelist,
  getTaskBoardDetails,
  taskUpdateStatus,
  ListBoardStatus,
  TaskUpdateTitleAssignee,
  deleteTask,
  getlabelList,
  createLabel,
  updateLabel,
  Taskedit,
  gettaskdata,
  getsprintList,
  addComments,
  gettaskcomments,
  addSubtask,
  getsubtaskList,
  updateSubtask,
  addBoardstatus,
  taskCreateSprint,
  taskStartSprint,
  taskUpdateSprint,
  getSprintBacklogData,
  deleteSprint,
  addTaskToSprint,
  createTaskToBacklog,
  updateTaskFromSprint,
  updateTaskFromBacklog,
  updateTaskwithSprint,
  taskManagementDeactivateProject,
  completeSprint,
  getSprintTaskSummary,
  moveTaskToSprint,
  getProjectAssigneeList,
  getEpicList,
  getLabelList,
  getStatusList,
  filteringBoardPage,
  boardFilterSprints,
  boardFilterAssignments,
  boardFilterLabels,
  boardFilterStatus,
  boardFilterEpics,
  taskManagementEditProject,
  taskManagementDeleteProject,
  taskManagementGetUnselectedEmployees,
  updateProjectDepartments,
  updateProjectTeamMembers,
  gettaskDetailsbyEpicId,
  gettaskDetailswithoutepic,
  delete_subtask,
  update_subtask_fields,
  delete_status_column,
  taskManagementGetProjectDetails,
  taskManagementRemoveTeamMembers,
  get_epic,
  getALLProjectRolePermissions,
  getSingleProjectPermission,
  addWorkItem,
  taskManagementAddEpic,
  filterBacklogTask,
  updateBoardStatusorder,
  getCurrentSprintTask,
  exportTaskData,
  getUpcomingFestivals,
  getTodaysLeaveMembers,
  getBirthDayList,
  getWorkAnniversary,
  getNewJoinersList,
  sendBirthDayWish,
  getDailyThoughts,
  getChatbotData,
  getActiveUsers,
  timeline_Sprintlist,
  timeline_Epiclist,
  gettimelinetask,
  UpdateTimelineTaskEpic,
  UpdateEpicDetails,
  UpdatesprintsDetails,
  addtaskwithEpic,
  getFeatureList,
  addFeature,
  assignFeature,
  getAssignedFeatureOrg,
  deleteFeature,
  deleteAssignedFeature,
  timelinefilterDetails,
  edit_comment,
  addEpicComments,
  getEpicComments,
  editEpiccomment,
  deletetaskcomment,
  getEpicdetails,
  getSubtaskById,
  updateSubtaskLabels,
  gettaskwithEpicId,
  createandADDepicLabels,
  deleteEpicComment,
  updatesubtaskdata,
  postSubtaskComment,
  getsubtaskComments,
  editSubtaskComment,
  Deletesubtaskcomment,
  getProjectTaskSubTaskData,
  getSummaryDashboard,
  getOrgUsersList,
  inviteUsersToOrg,
  acceptOrgInvite,
  updateEpicposition,
  getListData,
  reorderTaskSprint,
  listFilteredDetails,
  getAdminTaskBoardDetails,
  sendProjectInvite,
  acceptProjectInvite,
  adminBoardDetails,

  uploadAttachment,
  getAttachment,
  deleteAttachment,
  downloadAttachment,

  shareWorkItem,
  getIssueTypes,

  getDashboardMetrics,

  timeTracking,
  getLoggedTime,
  getHistoricalWorkLogs,
  getWorkLogTime,
  updateLogTime,
  deleteLoggedTime,
  listLinkTypes,
  createLinkType,
  listOfWorkItemstoLink,
  LinkWorkItems,
  deletelinkType,
  updateLinkTypeStatus,
  getLinkedWorkItems,
  fetchLinkedWorkItemsCount,
  deleteLinkType,

  getIcons,
  createSpace,
  getSpaces,
  getSpaceDetails,
  getSpaceContent,
  getYourSpaces,
  getTrashedSpaces,
  createPageDraft,
  renameContent,
  createFolder,
  getTemplate,
  postPageContent,
  getPageContent,
  movePageOrFolders,
  deleteorArchivePgorFolder,
  duplicateContent,
  templateDraftPage,
  starShortcut,
  publishPage,
  getSpaceUser,
  postpageComment,
  getPageComment,
  editPageComment,
  deletePageComment,
  shareItem,
  getArchivedSpaces,
  restoreOrTrash,
  getVersionHistory,
  getStarredContent,
  postSpaceAttachment,
  getSpaceAttachments,
  deleteSpaceAttachment,
  geOwnerSpaces,
  getArchivedandDeletedItems,
  restoreTrashedContent,
  deleteDraftPage,
  compareVersion,
  savePageData,
  restorePageVersion,
  deleteVersion,
  getAllOrgUsers,
  addUsersToSpace,
  permanentlyDeleteItem,
  removeMembersFromSpace,
  createWhiteBoard,
  postWhiteboardContent,
  getVersionDetails,
  createDatabase,
  getColumnList,
  databaseFilters,
  getSavedFilters,
  deleteSavedFilters,
  columnCalculation,
  contentExport,
  allSpacePermission,
  singleSpacePermission,


  updateHorizontalDashboardConfig,
  getHorizontalDashboardConfig,
  updateMetricSequence,
  getMetricSequence,
  getVerticalDashboardConfig,
  updateVerticalDashboardConfig,
  getVerticalWidgetSequence,
  updateVerticalWidgetSequence,

  addWebLink,
  getWebLink,
  deleteWebLink,
  createDemoProject,
  updateTourStatus,
  updateProjectTourStatus,
  getSubscriptionPlans,
  createPlan,
  updatePlan,
  changePlanStatus,
  getOrgSubscription,
  assignPlan
};

export default authService;
